export enum Instrument {
  LOAN = 'Loan',
  RESULT_BASED = 'ResultBased',
  GRANT = 'Grant',
  EQUITY = 'Equity',
  GUARANTEE = 'Guarantee',
  OTHER = 'Other',
}
